import {StyleSheet} from 'react-native';
import {Colors} from '../../constants/Colors';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'white',
    paddingHorizontal: 20,
    paddingVertical: 10,
    marginBottom: 85,
  },
  containerHeader: {
    marginTop: 30,
    marginBottom: 20,
  },
  description: {
    textAlign: 'center',
    fontSize: 12,
    fontFamily: 'TCCC-UnityHeadline Regular',
    lineHeight: 18,
    maxWidth: 250,
    alignSelf: 'center',
    color: Colors.GrayPallete.lightgrayThree,
  },
  error: {
    color: 'black',
    fontSize: 16,
    fontFamily: 'TCCC-UnityText Regular',
  },
  containerFilter: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 10,
    marginBottom: 10,
  },
  orders: {
    fontSize: 16,
    fontFamily: 'TCCC-UnityText Bold',
    lineHeight: 19,
    color: 'black',
    marginBottom: 10,
  },
  button: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  filter: {
    marginRight: 10,
    fontSize: 12,
    fontFamily: 'TCCC-UnityHeadline Regular',
    lineHeight: 14,
    color: Colors.RedPallete.red,
  },
  containerFlat: {
    marginTop: 40,
  },
  filterButton: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 15,
  },
  filterText: {
    marginRight: 10,
    fontSize: 12,
    fontFamily: 'TCCC-UnityHeadline Regular',
    lineHeight: 14,
    color: Colors.RedPallete.red,
  },
  buttonFilter: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  products: {
    fontSize: 16,
    fontFamily: 'TCCC-UnityText Bold',
    lineHeight: 19,
    color: 'black',
  },
  containerError: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    text: 'black',
  },

  // PAG-01 (26/08/2026) — seção "A pagar hoje", os pedidos à vista que o
  // vendedor montou no PDV e que vencem às 23:59.
  //
  // ⚠️ Nomes PRÓPRIOS, e não os de `renderPendingPaymentsSection`: aquela seção
  // referencia `pendingPaymentsSection`/`sectionTitle`/`sectionDescription`,
  // que NÃO existem neste arquivo — são `undefined` em runtime (o RN tolera, e
  // a seção sai sem estilo). Criar essas três chaves agora consertaria o
  // defeito e mudaria de lambuja o visual de uma seção que ninguém pediu para
  // mexer; fica registrado como achado, não corrigido aqui.
  avistaSection: {
    marginTop: 8,
    marginBottom: 16,
  },
  avistaTitle: {
    fontSize: 16,
    fontFamily: 'TCCC-UnityText Bold',
    lineHeight: 19,
    color: 'black',
    marginBottom: 4,
  },
  avistaDescription: {
    fontSize: 13,
    fontFamily: 'TCCC-UnityText Regular',
    lineHeight: 16,
    color: '#666',
    marginBottom: 10,
  },
  avistaCard: {
    borderWidth: 1,
    borderColor: Colors.RedPallete.red,
    borderRadius: 8,
    padding: 12,
    marginBottom: 8,
    backgroundColor: '#FFF6F6',
  },
  // Título e valor na MESMA linha, pontas opostas: é o que faz dois cards
  // "Pedido a pagar" ficarem distinguíveis num relance, sem o cliente ter
  // de ler a linha de itens embaixo primeiro.
  avistaCardHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  avistaCardValor: {
    fontSize: 16,
    fontFamily: 'TCCC-UnityText Bold',
    lineHeight: 19,
    color: 'black',
  },
  avistaCardTitulo: {
    fontSize: 15,
    fontFamily: 'TCCC-UnityText Bold',
    lineHeight: 18,
    color: 'black',
  },
  avistaCardItens: {
    fontSize: 13,
    fontFamily: 'TCCC-UnityText Regular',
    lineHeight: 16,
    color: '#444',
    marginTop: 2,
  },
  avistaCardAcao: {
    fontSize: 13,
    fontFamily: 'TCCC-UnityText Bold',
    lineHeight: 16,
    color: Colors.RedPallete.red,
    marginTop: 6,
  },
});
